import React, {useState, useEffect} from 'react'
import DigitsInput from '../../../Component/DigitsInput'
import Logo from '../logo.png'
import { useHistory } from 'react-router-dom';
import { showToast } from '../../../Component/Toast';
import Button from '../../../Component/Button'
import axios from 'axios';
import Spinner from '../../../Component/Loader'
import useClientHook from '../../../Hooks/useClientHook';

export default function Render() {

	let HISTORY = useHistory();
	let {client_id, origin} = useClientHook('USER')

	let params = new URLSearchParams(window.location.search)
	let Email = params.get('email')||params.get('prefill');

	const [OTP, setOTP] = useState(undefined);
	const [BtnLoader, setBtnLoader] = useState(false);
	const [Loader, setLoader] = useState();
	const [LoginMessage, setLoginMessage] = useState();


	useEffect(() => {
		if (params.get('success') === 'false') {
			setLoginMessage(new URLSearchParams(window.location.search).get('message'))
		}

	}, [ params, HISTORY, Email]);

	const resendOTP = () => {
		setBtnLoader(true)
		axios.post(`https://auth.dice.tech/auth/personal/username`, {email: Email,client_id}).then(res => {
			setBtnLoader(false)

		}).catch(err => {
			setBtnLoader(false)
			showToast({
				type: 'error',
				message: err.response ? err.response.data.message : "Something went Wrong !"
			})
		})
	}

	const submitForm = e => {
		let otp = OTP;

		if (!otp) {
			showToast({
				type: 'error',
				message: "Please enter OTP"
			})
			return
		}

		const form = document.createElement('form');
		form.method = "post";
		form.action = "https://auth.dice.tech/auth/personal/verify";

		let params = {
			email: Email,
			otp,
			client_id,
			referrer: window.location.origin,
		}

		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				const hiddenField = document.createElement('input');
				hiddenField.type = 'hidden';
				hiddenField.name = key;
				hiddenField.value = params[key];
				form.appendChild(hiddenField);
			}
		}
		document.body.appendChild(form);
		try {
			setLoader(true)
			form.submit();
		} catch (err) {
			setLoader(undefined)
			showToast({
				type: 'error',
				message: err.response ? err.response.data.message : "Something went Wrong !"
			})
		}

	}

	if (Loader || !client_id) {
		return <div className='w-100 vh-100 d-flex align-items-center justify-content-center' style={{background: '#fff'}}><Spinner/></div>
	}

	return (
		<div className="bg-white d-flex align-items-center overflow-hidden" style={{height:'100vh',textTransform: 'none'}}>
			<div className='text-center w-100 p-4'  style={{maxWidth: 450, margin: 'auto'}}>
				<h1 className="display-6 fw-bold">Verify</h1>
				<p>Enter OTP sent on {Email}, <span onClick={resendOTP} className='fw-bold' style={{cursor:'pointer', textDecoration: 'underline'}}>Resend OTP</span></p>
				<div className="mt-4 mb-2 text-start">
					<DigitsInput label='Enter OTP' digits={6} onChange={setOTP}/>
				</div>
				{
					LoginMessage ?
					<p className='text-danger text-left' style={{fontSize: '0.8rem', textAlign: 'left'}}>
						<svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path></svg>
						{LoginMessage}
					</p>
					: <></>
				}
				<p className="text-start mt-3" style={{fontSize: '0.9rem'}}>Don't have an account?
					&nbsp;<strong><a className="text-dark" href="/personal/new">Create account</a></strong>
					<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-arrow-right-circle-fill ms-1"><path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" /></svg>
				</p>

				<Button onClick={()=>{submitForm()}} name='Log in' loading={BtnLoader}/>
				<button onClick={()=>HISTORY.push(`/?origin=${origin}`)} className="btn w-100 btn-outline-dark mt-3 p-2" x="button" style={{borderWidth: 2}}><img alt='Logo' className="me-4 mb-1" src={Logo} style={{maxWidth: 20}} />Log in with Dice</button>
			</div>
		</div>
	)
}
